<template>
  <VanPopup
    :show="show"
    @update:show="($event:boolean) => $emit('update:show', $event)"
    class="h-[80%] overflow-hidden"
    position="bottom"
  >
    <ThreadsNav show-back :go-back="clickBack">
      <template #center>
        {{ $t(`painting.muti.${list ? "selectTrait" : "selectMate"}`) }}
      </template>
      <template #right>
        <button
          class="btn btn-sm btn-primary"
          :disabled="!activeTrait?.id"
          @click="emit('selectTrait', activeTrait!), emit('update:show', false)"
        >
          {{ $t(`Buttons.confirm`) }}
        </button>
      </template>
    </ThreadsNav>
    <!-- 选择Mate -->
    <div class="text-center mt-10" v-if="loading">
      <div class="loading loading-ring" />
    </div>
    <div class="flex flex-col h-full" v-else-if="!list">
      <div class="flex-1 w-full overflow-auto">
        <div
          v-for="(item, idx) in mateStore.list.filter((item) => item.name)"
          :key="idx"
          class="flex gap-2 items-center p-2 relative"
          @click="clickSelectMate(item)"
        >
          <div class="w-full flex py-2 h-28 gap-4">
            <div class="h-full aspect-[3/4] relative">
              <BaseImg
                :width="140"
                :url="item.mediaUrl"
                class="h-full aspect-[3/4]"
              />
            </div>
            <div class="flex-1">
              <h2>{{ item.name }}</h2>
              <p class="mt-1 line-clamp-3 text-base-content/50 text-sm">
                {{ item.bio }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择特征 -->
    <div
      v-else
      class="max-h-full overflow-auto flex flex-wrap gap-1 pb-20 justify-evenly"
    >
      <div v-if="!list.length">
        <VanEmpty :description="$t('Message.noTraitsAvailable')" />
      </div>
      <div
        v-else
        v-for="(item, idx) in list"
        :key="idx"
        :class="[
          activeTrait?.id === item.id
            ? 'border-primary border rounded'
            : 'border border-transparent ',
        ]"
        class="flex items-center relative"
        @click="activeTrait = item"
      >
        <div class="w-20">
          <div class="h-full relative text-center">
            <BaseImg :media="item.media || item.source" />
            <h2 class="line-clamp-1">{{ item.name }}</h2>
          </div>
        </div>
      </div>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { useMate } from "@/stores/mate";
import { useMateTrait } from "@/stores/mateTrait";
import { watch } from "vue";
import { ref } from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  filterIds: {
    type: Array,
    default: () => [],
  },
});

watch(
  () => props.show,
  (val) => {
    if (val) {
      list.value = undefined;
    }
  }
);

const emit = defineEmits({
  "update:show": (val: boolean) => undefined,
  selectTrait: (trait: MateTrait) => undefined,
});

const clickBack = () => {
  activeTrait.value = undefined;
  if (list.value) list.value = undefined;
  else emit("update:show", false);
};

const loading = ref(false);
const mateStore = useMate();
const traitStore = useMateTrait();
const list = ref<MateTrait[]>();

const clickSelectMate = async (mate: Mate) => {
  loading.value = true;
  list.value = await traitStore.getOrFetchTraitListById(mate.id!);
  const filterMap = new Map(props.filterIds.map((id) => [id, true]));
  list.value = list.value?.filter((item) => !filterMap.has(item.id));
  loading.value = false;
};

const activeTrait = ref<MateTrait>();
</script>
